<template>
  <div class="patient-list">
    <div class="patient_list">
        <van-list v-model="loading" :finished="finished" @load="onLoad" >
            <van-cell-group  inset class="cell-group">
                <van-cell v-if="parseInt(times) != 0"><template #title>您帮助{{list_title}}的患者</template></van-cell>
                <van-cell center  :border="false" v-for="item,index in list" :key="index" is-link @click="goForDetail(item)">
                    <template #title>
                     <div class="avatar-background">
                        <div class="patient-id"><div class="up-layer">{{item.patient_id}}</div></div>
                     </div>
                    </template>   
                    <div class="patient_info">
                      <div style="color:#323233;white-space:nowrap;">{{item.name}}</div>
                      <div>{{item.updated}}</div>
                    </div>
                </van-cell>
            </van-cell-group>
            <template #finished>
                <van-divider v-if="parseInt(times) == 0" :style="{ color: '#bababa', borderColor: '#bababa', padding: '0 16px 18px'}">暂无数据</van-divider>
                <van-divider :style="{ color: '#bababa', borderColor: '#bababa', padding: '0 80px'}">
                    <div style="width:3px;height:3px;border-radius:100%;background-color:#bababa;"></div>
                </van-divider>
            </template>
        </van-list>

    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { List } from 'vant';
import { Divider } from 'vant';
import { mapState } from "vuex";
import { getAssistanceLog,hasPatient } from '@/api/publicWelfareStaff';

Vue.use(Divider);
Vue.use(List);
export default {
    data(){
        return {
          searchValue: '',
          list_title: '',
            
          //无限加载列表
          list: [],
          loading: false,
          finished: false,
          times: null,

          page:1,

          date:'',
        }
    },
    computed: {
      ...mapState(['publicWelfareStaff'])
    },
    async created() {
      if(this.$route.query.times) this.times = this.$route.query.times
      if(this.$route.query.title) this.list_title = this.$route.query.title
      if(this.$route.query.date) this.date = this.$route.query.date
      console.log(this.times,this.list_title,this.date,"this.times,this.list_title,this.date")
      // console.log(parseInt(this.times) != 0,"parseInt(times) != 0")
      
    },
    methods: {
      async getList(page){
        let list_data = []
        await getAssistanceLog({
          volunteer_id: this.publicWelfareStaff.checkin_info.papid,
          type: this.list_title,
          page: page,
          date:this.date
        }).then(res => {
          list_data = res.data
          console.log("患者列表：",res)
          this.list=[...this.list,...res.data]
        })
        return list_data
      },
      async onLoad() {
        // 异步更新数据
        // setTimeout 仅做示例，真实场景中一般为 ajax 请求
        await this.getList(this.page).then(res => {
          if (res.length>0) this.page++

          // 加载状态结束
          this.loading = false;

          // 数据全部加载完成
          if (res.length==0) {
              this.finished = true;
          }
        })

      },
      async goForDetail(item) {
        //查看患者详情
        console.log("!",item)
        // return
            console.log("去患者详情")
            this.$router.push({
                name:"patientDetial",
                query:{
                  papid:item.patient_id,
                  name:item.name,
                  // mobile: item.mobile,
                  // front_status:item.front_status, 
                }
            })

      },
      // addVisit(item){
      //   // 新增/修改记录
      //   console.log(item?"修改记录":"新增记录")
      //   const title = item?"更新患者服务":"新增医护拜访"
      //   //存储返回的路径名
      //   this.$store.commit("setOriginRoute", this.$route.name);

      //   this.$router.push({name:'addVisit',query:{'title':title}})
      // },
    }
}
</script>

<style lang="scss" scoped>
.patient-list{
    min-height: 100vh;
    background-color: #F9F9F9 ;
    padding-top: 15px;
    
    font-size: 16px;
    // ::v-deep .grey_label{
    //     color:#9D9D9D;
    //     white-space:nowrap;
    // }
    .van-search{
        padding:16px;
    }
    .van-cell-group {
      // background: pink;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
    .cell-group{
        margin-bottom:10px;
        .avatar-background {
          // box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
          // padding: 3px;
          // border-radius: 100%;
          // background: #f9f9f9;

          display: flex;
          justify-content: center;
          align-items: center;
          // margin-left: -10px;
          .patient-id{
              width: 50px;
              height: 50px;
              border: 1px solid rgba(0, 0, 0, 0.2);
              box-shadow: 0 0 3px  3px rgba(0, 0, 0, 0.01);
              border-radius: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              // margin-right: 10px;
              .up-layer{
                color:white;
                font-weight:bold;
                width: 44px;
                height: 44px;
                background-color: #8ddbdf;
                // padding:5px;
                border-radius: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
              }
          }
        }
        .patient_avatar{
            // background: pink;
            display: flex;
            flex: none;
        }
        .patient_info{
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            // background: pink;
            margin-left: 5px;
        }
        .detail_btn{
            text-align: right;
            color: #0A0A0A;
            padding-right: 15px;
            padding-bottom: 20px;
            font-size: 15px;
        }
        .van-cell__title {
            flex: none;
        }
        .van-cell__value{
            flex: 1;
        }
    } 
}
</style>